import React from "react";
import { useAuth } from "../contexts/AuthContext";

const Dashboard: React.FC = () => {

  return (
    <div>
      <div className="mx-auto max-w-7xl">
        {/* 3 column wrapper */}
        <div className="flex-wrap mx-auto w-full max-w-7xl grow lg:flex xl:px-2">
          <div className="flex-1 shrink-0 border-base-300 py-6lg:w-96 lg:border-t-0 lg:pr-8 xl:pr-6">
            {/* Welcome */}
            <div className="overflow-hidden">
              <div className="px-8 pb-6 sm:p-6">
                <div>
                  <h1 className="text-3xl font-bold font-heading text-base-content">
                    <span className="font-light">My </span> Circles
                  </h1>
                  <div className="bg-base-300 p-2 py-2 rounded-md mt-2">
                    <p className="text-base-content/70 text-xs font-mono">
                      See squads, clubs, communities and groups you are linked
                      with.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Training Squad */}
            <div className="bg-base-100 rounded-lg p-6 mt-3 items-center m-4">
              <div className="flex justify-between items-center">
                <h3 className="text-2xl font-heading font-semibold">
                  My Coaching Group
                </h3>
                <div className="text-xs ml-2 font-mono text-base-content/50">
                  3 members
                </div>
              </div>
              <div className="rounded-md">
                <p className="text-xs text-base-content/50 font-mono">public</p>
              </div>
            </div>

            {/* Peak Run Club */}
            <div className="bg-base-100 rounded-lg p-6 mt-3 items-center m-4">
              <div className="flex justify-between items-center">
                <h3 className="text-2xl font-heading font-semibold">
                  Peak Run Club
                </h3>
                <div className="text-xs ml-2 font-mono text-base-content/50">
                  32 members
                </div>
              </div>
              <div className="rounded-md">
                <p className="text-xs text-base-content/50 font-mono">public</p>
              </div>
            </div>
          </div>

          <div className="flex-1 xl:flex mt-3">
            <div className="px-6 py-6 sm:px-6 lg:pl-8 xl:flex-1 xl:pl-6 bg-base-100 rounded-md shadow-sm">
              <p>Create a circle</p>
              <p>Join a Circle</p>
              <p>Explore circles</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
